import React, { useCallback, useMemo, useState } from 'react';
import { NumericFields, NumericRangeType } from '@decisions/server/DecisionsFramework/Design/Page/Filters';
import './data-filter-fields.less';
import { RangePickerField } from './RangePickerField';
import { DataFilterField, IDataFilterFieldCommonProps } from './DataFilterField';
import './NumericRangeField.less';
import { convertToFloat } from 'utils/NumberUtils';
import debounce from 'debounce';

export interface INumericFieldsFilterProps extends IDataFilterFieldCommonProps<NumericFields> {}

export function NumericFieldsFilter({ onChange, personalization, validation, value }: INumericFieldsFilterProps) {
  const [numericFields, setNumericFields] = useState(value);
  const onFieldChange = () => {};
  const { MatchType: rangeType } = value;

  const onValueChange = useCallback(() => {
    onChange(numericFields);
  }, [onChange, numericFields]);

  const emitValueChange = useMemo(() => debounce(onChange, 300), [onChange]);

  const onMinValueChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      emitValueChange.clear();
      const updatedValue = { ...numericFields, Above: convertToFloat(e.target.value) };
      setNumericFields(updatedValue);
      emitValueChange(updatedValue);
    },
    [emitValueChange, numericFields]
  );

  const onMaxValueChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      emitValueChange.clear();
      const updatedValue = { ...numericFields, Below: convertToFloat(e.target.value) };
      setNumericFields(updatedValue);
      emitValueChange(updatedValue);
    },
    [emitValueChange, numericFields]
  );

  return (
    <DataFilterField
      value={value}
      fieldText={''}
      onChange={onValueChange}
      onFieldChange={onFieldChange}
      validation={validation}
      personalization={personalization}
    >
      {({ keyHandler }) => (
        <div className="dp-numeric-range-field__fields">
          <RangePickerField
            label="Min"
            onChange={onMinValueChange}
            value={numericFields.Above.toString()}
            show={rangeType === NumericRangeType.Between}
            onKeyDown={keyHandler}
          />
          <RangePickerField
            label="Max"
            onChange={onMaxValueChange}
            value={numericFields.Below.toString()}
            show={rangeType === NumericRangeType.Between}
            onKeyDown={keyHandler}
          />
        </div>
      )}
    </DataFilterField>
  );
}
